<template>
  <div class="event-password-login-container">
    <h1>{{ $t('eventPasswordRequired') }}</h1>
    <h2>{{ $t('eventPasswordDescription') }}</h2>
    <form @submit.prevent="submitPassword">
      <div class="password-input-container">
        <text-field
          v-model="password"
          :validator="$v.password"
          :label="$t('passwordLabel')"
          :type="showPasswordInput ? 'text' : 'password'"
          :append-icon="showPasswordInput ? 'visibility_off' : 'visibility'"
          @clickAppendIcon="showPasswordInput = !showPasswordInput"
        />
      </div>
      <main-button color="black" style="float: right">{{ $t('continue') }}</main-button>
    </form>
    <simple-snackbar v-bind.sync="snackbar" />
  </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import { VERIFY_EVENT_PASSWORD } from '@/graphql/eventPasswords.graphql'
import SimpleSnackbar from '@/components/shared/snackbars/simple-snackbar.vue'

export default {
  name: 'event-password-login',
  components: { SimpleSnackbar },
  props: {
    eventId: String,
    gateContext: { type: String, default: null },
  },
  data() {
    return {
      password: null,
      snackbar: null,
      showPasswordInput: false,
    }
  },
  validations() {
    return {
      password: { required },
    }
  },
  methods: {
    async submitPassword() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }

      const eventId = this.eventId
      const gateContext = this.gateContext
      const attempt = this._passwordAttempt = (this._passwordAttempt || 0) + 1
      let data
      try {
        const result = await this.$apollo.query({
          query: VERIFY_EVENT_PASSWORD,
          fetchPolicy: 'no-cache',
          variables: {
            eventId: this.eventId,
            password: this.password,
          },
        })
        if ((result.errors && result.errors.length) || !result.data) throw new Error('Password verification failed')
        data = result.data
      } catch (error) {
        this.snackbar = { open: true, messageProp: 'Something went wrong', color: 'error' }

        return
      }

      if (this._isDestroyed || this.eventId !== eventId || this.gateContext !== gateContext || this._passwordAttempt !== attempt) return

      if (!data.verifyEventPassword) {
        this.snackbar = {
          open: true,
          messageProp: 'Wrong password',
          color: 'error',
        }

        return
      }

      this.$emit('acceptEventPassword', gateContext)
    },
  },
}
</script>

<style scoped>
.event-password-login-container {
  max-width: 37.25rem;
  width: 100%;
  margin: auto;
}

h1 {
  color: #333;
  text-align: center;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 2.25rem;
  font-style: normal;
  font-weight: 800;
  line-height: 120%;
  letter-spacing: -0.0675rem;

  margin-bottom: 1.5rem;
}

h2 {
  color:  #666;
  text-align: center;
  font-family: "Source Sans Pro";
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;

  margin-bottom: 3rem;
}

.password-input-container {
  padding: 1.5rem 1.5rem 2px 1.5rem;
  border-radius: 0.25rem;
  border: 1px solid rgba(151, 151, 151, 0.50);
  background: #FFF;
  margin-bottom: 1.5rem;
}
</style>
